import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';

export const InitialLoading = () => (
	<Box
		sx={{
			minWidth: '600px',
			minHeight: '75vh',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		}}
	>
		<CircularProgress />
		<p>Loading document...</p>
	</Box>
);

export const FetchingMorePages = ({ isVisible }) => (
	<Box
		sx={{
			textAlign: 'center',
			margin: '0',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			visibility: isVisible ? 'visible' : 'hidden'
		}}
	>
		{isVisible && (
			<>
				<CircularProgress size={20} />
				<p style={{ marginLeft: 10, color: 'rgb(217, 217, 217)'}}>Loading more pages...</p>
			</>
		)}
	</Box>
);

FetchingMorePages.propTypes = {
	isVisible: PropTypes.bool.isRequired
};
